<!-- Skeleton shown while async data is loading -->
@if (isFormLoading) {
  <c-card>
    <c-card-body>

      <!-- Header: entity type name + create/edit subtitle -->
      <optima-progress-indicator
        [progress]="formLoadingProgress"
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'header-title',    width: '45%', height: '1.4rem', marginBottom: '0.35rem' },
          { id: 'header-subtitle', width: '60%', height: '0.9rem', marginBottom: '1.5rem' }
        ] } }">
      </optima-progress-indicator>

      <!-- Base entity fields: name · description · owner+parent (row) · icon -->
      <optima-progress-indicator
        [progress]="formLoadingProgress"
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'field-name',        width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-description', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-owner',  width: '48%',  height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-parent', width: '48%',  height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-icon',   width: '60%',  height: '2.5rem', marginBottom: '1.75rem' }
        ] } }">
      </optima-progress-indicator>

      <!-- KPI-specific fields (measure, date range etc.) -->
      <optima-progress-indicator
        [progress]="formLoadingProgress"
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'kpi-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'kpi-field-2', width: '100%', height: '2.5rem', marginBottom: '1.75rem' }
        ] } }">
      </optima-progress-indicator>

      <!-- Biz Rules section -->
      <div class="mb-3">
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'biz-rules-heading', width: '25%', height: '1rem', marginBottom: '0.75rem' }
          ] } }">
        </optima-progress-indicator>
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'biz-rules-content', width: '100%', height: '4rem', marginBottom: '1.5rem' }
          ] } }">
        </optima-progress-indicator>
      </div>

      <!-- Section: Additional Info -->
      <div class="mb-1">
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'additional-info-heading', width: '30%', height: '1rem', marginBottom: '1rem' }
          ] } }">
        </optima-progress-indicator>
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'additional-info-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
            { id: 'additional-info-field-2', width: '80%',  height: '2.5rem', marginBottom: '1.75rem' }
          ] } }">
        </optima-progress-indicator>
      </div>

      <!-- Section: Relationships -->
      <div class="mb-3">
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'relationships-heading', width: '28%', height: '1rem', marginBottom: '0.75rem' }
          ] } }">
        </optima-progress-indicator>
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'relationships-label',   width: '40%',  height: '0.9rem', marginBottom: '0.75rem' },
            { id: 'relationships-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
            { id: 'relationships-field-2', width: '75%',  height: '2.5rem', marginBottom: '1.75rem' }
          ] } }">
        </optima-progress-indicator>
      </div>

      <!-- Submit button row -->
      <div class="d-flex justify-content-end mt-2">
        <optima-progress-indicator
          [progress]="formLoadingProgress"
          [view]="ProcessProgressView.Shimmer"
          [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'submit-button', width: '10rem', height: '2.4rem', borderRadius: '0.375rem' }
          ] } }">
        </optima-progress-indicator>
      </div>

    </c-card-body>
  </c-card>
}

<!-- Real form — always in DOM so child ngOnInit async work runs in parallel -->
<c-card [hidden]="isFormLoading" class="form-biz-entity-card">
  <c-card-header>
    <div class="h2 mb-0">{{ formHeaderTitle }}</div>
    <small>{{ formHeaderSubtitle }}</small>
  </c-card-header>
  <c-card-body class="form-biz-entity-scroll-body">
    <app-form-base-entity #baseEntityForm [bizEntity]="kpiBizEntity" [isEditing]="isEditing"
      [parentExplorer]="parentExplorer"
      (formReady)="onFormReady()"
      [excludeParentAndOwner]="false">
    </app-form-base-entity>

    <optima-form-layout [layout]="formLayout">
    </optima-form-layout>
<div class="pb-3 px-3"
              style="display: flex; justify-content: space-between; flex-direction: row; align-items: center;">
              <div>
                <h6 style="margin-bottom:0px!important">Biz Rules</h6>
              </div>
              <div>
                <button class="btn" (click)="openBizRuleEditor()" [disabled]="isBizRuleButtonDisabled">{{ isEditing ? 'Edit' : 'New' }}</button>
              </div>
            </div>
            <div>
              @if (bizRuleSelectionsListerView?.items && bizRuleSelectionsListerView.items.length > 0) {
                <optima-lister
                  [list]="bizRuleSelectionsListerView"
                  [hasHeader]="false"
                  [hasColHeaders]="true"
                  [height]="'20vh'">
                </optima-lister>
              }
            </div>
    @if(kpiBizEntity && kpiBizEntity.additionalInfo && kpiBizEntity.additionalInfo.length > 0) {
  <app-additional-info #additionalInfoForm [bizEntity]="kpiBizEntity">
  </app-additional-info>
}

@if (relationshipConfigurations && relationshipConfigurations.length > 0) {
  <div class="relationship-section mb-4">
    <h6 class="mb-3">Relationships</h6>
     @for (config of relationshipConfigurations; track config; let i = $index) {
      <app-form-relationship-fields 
        #relationshipFields
        [config]="config"
        [isEditing]="isEditing"
        [parentBizEntity]="kpiBizEntity"
        [linkedBizEntities]="getTargetBizEntity(config)"
        [BizEntities]="bizEntities"
        (bizEntityAdditionalInfo)="onBizEntityAdditionalInfo($event, i)"
        (bizEntityAdditionalInfoForEdit)="onBizEntityAdditionalInfoForEdit($event)">
      </app-form-relationship-fields>
    }
  </div>
}

  </c-card-body>
  <div class="form-biz-entity-footer">
    <optima-form-layout [layout]="formFooterLayout" (formDataChange)="onCreateKPI()"></optima-form-layout>
  </div>
</c-card>
